export {Modal} from 'antd';
export type {ModalFuncProps, ModalProps} from 'antd/es/modal/index';
